import { makeTrackEvent } from '@termly-web/common'

export default makeTrackEvent('dashboard')
